export const environment = {
  production: true,
  version: "5.0.6.1",
};
